import { bootstrapSession, qk } from "@profitlens/api-client";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import type { ReactNode } from "react";

import { useAuthStore } from "@/stores/auth-store";

/**
 * On start, if a session marker exists, try a silent refresh (httpOnly cookie) and
 * seed the query cache with `/auth/me` so the first paint already has user + tenant.
 */
export function SessionBootstrap({ children }: { children: ReactNode }) {
  const queryClient = useQueryClient();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    const { status, setStatus, expire } = useAuthStore.getState();
    if (status !== "unknown") return;

    started.current = true;
    setStatus("authenticating");

    void bootstrapSession()
      .then((me) => {
        if (!me) {
          expire();
          return;
        }
        queryClient.setQueryData(qk.me, me);
        if (me.tenant) queryClient.setQueryData(qk.tenant, me.tenant);
        useAuthStore.setState({ status: "authenticated" });
      })
      .catch(() => expire());
  }, [queryClient]);

  return <>{children}</>;
}
